import base from './base'
import survey from './survey'
import malls from './malls'
import company from './company'
import businessCard from './businessCard'
import uplaod from './upload'
import dynamic from './dynamic'
import customer from './customer'
import website from './website'
import appointment from './appointment'
import house from './house'
import sweepPayment from './sweepPayment'
import system from './system'
import groupPush from './groupPush'
import poster from './poster'
import article from './article'
import activity from './activity'
import renovation from './renovation'
import diy from './diy'
import fitness from './fitness'
import prettify from './prettify'
import baidu from './baidu'
import present from './present'
import closure from './closure'
import cash from './cash'
import reduction from './reduction'
import live from './live'
import shortvideo from './shortvideo'
import distributions from './distribution'
export default {
  ...survey,
  ...malls,
  ...company,
  ...businessCard,
  ...uplaod,
  ...dynamic,
  ...customer,
  ...website,
  ...appointment,
  ...house,
  ...sweepPayment,
  ...system,
  ...groupPush,
  ...poster,
  ...article,
  ...activity,
  ...base,
  ...renovation,
  ...diy,
  ...fitness,
  ...prettify,
  ...baidu,
  ...present,
  ...closure,
  ...cash,
  ...reduction,
  ...live,
  ...shortvideo,
  ...distributions
}



// WEBPACK FOOTER //
// ./src/api/modules/index.js